<template>
    <div v-show="isCurrent">
        <slot />
    </div>
</template>

<script setup lang="ts">
const instanceKey = getCurrentInstance().vnode.key as string;

const props = withDefaults(
    defineProps<{
        title: string;
        enabled?: boolean;
    }>(),
    {
        enabled: true,
    },
);

const currentTab = inject('currentTab') as Ref<string | null>;
const registerTab = inject('registerTab') as (
    key: string,
    title: string,
    enabled: boolean,
) => void;
const setTabEnabled = inject('setTabEnabled') as (
    key: string,
    enabled: boolean,
) => void;

const isCurrent = computed<boolean>(() => {
    return currentTab.value === instanceKey;
});

watch(
    () => props.enabled,
    (enabled) => {
        setTabEnabled(instanceKey, enabled);
    },
);

onMounted(() => {
    registerTab(instanceKey, props.title, props.enabled);
});
</script>
